module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_kit@2x-f58a233385e136b1d391a35c53d4e9d4.jpg";